export function getIsDateInFuture(date: string) {
    const todayTimestamp = new Date(new Date().setHours(0, 0, 0, 0)).getTime();
    const dateTimestamp = new Date(new Date(date).setHours(0, 0, 0, 0)).getTime();
    return dateTimestamp > todayTimestamp;
}
